import React, { useEffect, useState } from "react";
import { ProfitDetailsProps } from "./types";
import { Tab } from "@material-ui/core";
import useStyles from "./styles";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../store";
import { ProductProfitStatisticsState } from "../../../../store/statistics/productprofit/types";
import { thunkFetchProductProfitStatistics } from "../../../../store/statistics/productprofit/actions";
import ProfitDetailsTable from "../ProfitDetailsTable";
import { Currency } from "../../../../components/misc/Currency";

const ProfitDetails = ({
  profitPerCategory,
  productProfit
}: ProfitDetailsProps) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = useState("1");

  const productProfitStatisticsState = useSelector<
    AppState,
    ProductProfitStatisticsState
  >(s => s.productProfitStatistics);
  let { productProfitStatistics } = productProfitStatisticsState;

  useEffect(() => {
    if (productProfit) {
      dispatch(
        thunkFetchProductProfitStatistics(
          productProfit.periodFrom,
          productProfit.periodTo,
          productProfit.storeId
        )
      );
    }
  }, [productProfit]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <TabContext value={selectedTab}>
      <TabList
        onChange={handleChange}
        className={classes.tabHeader}
        TabIndicatorProps={{ className: classes.indicator }}
      >
        <Tab
          label={"Profit by product category"}
          value="1"
          className={classes.tabEntry}
        />
        <Tab
          label={"Profit by product"}
          value="2"
          className={classes.tabEntry}
        />
      </TabList>

      <TabPanel value="1" className={classes.tabPanel}>
        <ProfitDetailsTable
          displayGraphSwitch={true}
          title={"Category"}
          profits={Array.from(profitPerCategory).map(([k, v]) => ({
            name: k,
            profit: v.profit,
            profitFormatted: <Currency value={v.profit} />,
            sales: v.sales,
            salesFormatted: <Currency value={v.sales} />,
            cost: v.cost,
            costFormatted: <Currency value={v.cost} />,
            waste: v.waste,
            wasteFormatted: <Currency value={v.waste} />,
            campaign: v.campaign,
            campaignFormatted: <Currency value={v.campaign} />,
            discount: v.discount,
            discountFormatted: <Currency value={v.discount} />
          }))}
        />
      </TabPanel>
      <TabPanel value="2" className={classes.tabPanel}>
        <ProfitDetailsTable
          title={"Product"}
          profits={productProfitStatistics.map(p => ({
            name: p.name,
            profit: p.profit,
            profitFormatted: <Currency value={p.profit} />,
            sales: p.sales,
            salesFormatted: <Currency value={p.sales} />,
            cost: p.cost,
            costFormatted: <Currency value={p.cost} />,
            waste: p.waste,
            wasteFormatted: <Currency value={p.waste} />,
            campaign: p.campaign,
            campaignFormatted: <Currency value={p.campaign} />,
            discount: p.discount,
            discountFormatted: <Currency value={p.discount} />
          }))}
        />
      </TabPanel>
    </TabContext>
  );
};
export default ProfitDetails;
